import cookbook_nav1 from "../../assets/cookbook_nav1.png";
import cookbook_nav2 from "../../assets/cookbook_nav2.png";
import cookbook_nav3 from "../../assets/cookbook_nav3.png";
import cookbook_nav4 from "../../assets/cookbook_nav4.png";
import cookbook_nav5 from "../../assets/cookbook_nav5.png";

export const navMap = [
  {
    title: "亲子咖喱",
    category_id: 1,
    goods: [],
    bg: cookbook_nav1,
  },
  {
    title: "节日特辑",
    category_id: 2,
    goods: [],
    bg: cookbook_nav2,
  },
  {
    title: "百搭咖喱",
    category_id: 3,
    goods: [],
    bg: cookbook_nav3,
  },
  {
    title: "快手咖喱",
    category_id: 4,
    goods: [],
    bg: cookbook_nav4,
  },
  {
    title: "家庭西餐",
    category_id: 5,
    goods: [],
    bg: cookbook_nav5,
  },
];
